/** Must match functions/src/qbWriteBackConfig.ts until we add a settings toggle. */
export const QB_WRITE_BACK_PAUSED = true;

export const QB_WRITE_BACK_PAUSED_MESSAGE =
  'QuickBooks sync is paused. Categorizations are saved in the CRM only.';
